import { Link } from "react-router-dom";
import { MAIN_ROUTE } from "@/utils/constants.js";
import "./brand-mark.css";

/**
 * Company logo (name is already in the image). Use `size="header"` in the top bar.
 */
export default function BrandMark({
    name,
    to = MAIN_ROUTE,
    className = "",
    size = "footer"
}) {
    const sizeClass = size === "header" ? " brand-mark--header" : "";
    const mark = (
        <span className={`brand-mark${sizeClass}${className ? ` ${className}` : ""}`}>
            <img
                className="brand-mark-logo"
                src="/logo.png"
                alt={name || ""}
                width={320}
                height={160}
                decoding="async"
            />
        </span>
    );

    if (!to) {
        return mark;
    }

    return (
        <Link to={to} className="brand-mark-link" aria-label={name}>
            {mark}
        </Link>
    );
}
